module.exports = __webpack_public_path__ + "static/media/Safe-pana.96ec44d2.svg";